"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const NotifyMeIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.619 3a3 3 0 11-6 0 3 3 0 016 0z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M7 11.413c0-.553.446-1 .997-1h.006c.55 0 .997.447.997 1 0 .552-.446 1-.997 1h-.006a.998.998 0 01-.997-1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.03 7.418v6.199c0 1.316-1.107 2.383-2.471 2.383H4.5c-1.364 0-2.47-1.067-2.47-2.383V2.383C2.03 1.067 3.135 0 4.5 0h4.54c-.508.576-.872 1.232-1.037 2h-3.65C4.158 2 4 2.195 4 2.383V13.66c0 .188.158.34.353.34h7.324a.347.347 0 00.352-.34V7.496c.286.052.462.079.762.079.429 0 .844-.055 1.238-.157z"
  })))
});
NotifyMeIcon.displayName = 'NotifyMeIcon';
var _default = exports.default = NotifyMeIcon;